import { Context } from "./Context";
import { usePopupState } from "./globalState/popupState";
import { useLoadingState } from "./globalState/loadingState";

export const StateProvider = ({ children }: any) => {
  const loading = useLoadingState();
  const popup = usePopupState();
  let store = Object.assign(loading, popup);
  return <Context.Provider value={store}>{children}</Context.Provider>;
};
